<template>
  <div class="user_show">
    <span>{{ $t('meta_title.user.archive.show') }}</span>

    <div v-if="user">
      <p><strong>{{user.firstname}} {{user.lastname}}</strong></p>
      <p>{{user.email}}</p>
      <p>{{user.roles}}</p>

      <router-link-guard :to="{ name: 'UserEditArchive', params: { id: user.id }}" :msg_slug="'action.archive.restore'" :authorization="'user_archive'"></router-link-guard>
      <router-link-guard :to="{ name: 'UserDeleteArchive', params: { id: user.id }}" :msg_slug="'action.archive.delete'" :authorization="'user_archive'"></router-link-guard>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'UserShowArchive',
    data() {
      return {
        user: [],
      }
    },
    created() {
      this.user.id = this.$route.params.id;
      this.$http.get(`user/archive/` + this.$route.params.id)
        .then(response => {
          this.user = response.data
        })
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/User/show_archive.vue